import { render, staticRenderFns } from "./UserDeliveryService.vue?vue&type=template&id=70431488&"
import script from "./UserDeliveryService.vue?vue&type=script&lang=js&"
export * from "./UserDeliveryService.vue?vue&type=script&lang=js&"
import style0 from "./UserDeliveryService.vue?vue&type=style&index=0&id=70431488&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports